import React from "react";
import { Card, CardBody, FormGroup, Input, Button } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { post, put } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  document.title = "Change Password | Elevated - Admin Dashboard";
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const validationSchema = Yup.object({
    previous: Yup.string().required("Old password is required"),
    password: Yup.string()

      .required("New password is required")
      .min(5, "Password must be at least 5 characters"),
    confirmPassword: Yup.string()
      .required("Confirm new password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await put(`${endpoints.user}/setpassword/${userId}`, {
        previous: values.previous,
        password: values.password,
      });

      if (response?.data?.success) {
        await put(`${endpoints.auth}/logout/${userId}`);
        navigate("/login");

        toast.success("Password Changed Successfully", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        resetForm();
      } else {
        throw new Error("API response indicates failure");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Old password is incorrect.",
        {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        }
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Card
        className="rounded-4"
        style={{
          borderRadius: "12px",
          minHeight: "550px",
        }}
      >
        <CardBody>
          <h2 className="font-size-20 ff-sora primary-black fw-bold">
            Change Password
          </h2>
          <p className="font-size-16 ff-sora secondary-black fw-normal">
            Please enter your old password and new password to update.
          </p>
          <Formik
            initialValues={{
              previous: "",
              password: "",
              confirmPassword: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <FormGroup>
                  <Field
                    type="password"
                    name="previous"
                    placeholder="Old password"
                    className="rounded-5 bg-light light-black font-size-16 ff-sora secondary-black fw-normal px-4"
                    style={{
                      width: "100%",
                      maxWidth: "412px",
                      height: "56px",
                      border: "none",
                    }}
                    as={Input}
                  />
                  <ErrorMessage
                    name="previous"
                    component="div"
                    className="text-danger font-size-12 ff-sora fw-normal my-1"
                  />
                </FormGroup>
                <FormGroup>
                  <Field
                    type="password"
                    name="password"
                    placeholder="New password"
                    className="rounded-5 bg-light light-black font-size-16 ff-sora secondary-black fw-normal px-4"
                    style={{
                      width: "100%",
                      maxWidth: "412px",
                      height: "56px",
                      border: "none",
                    }}
                    as={Input}
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="text-danger font-size-12 ff-sora fw-normal my-1"
                  />
                </FormGroup>
                <FormGroup>
                  <Field
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm new password"
                    className="rounded-5 bg-light light-black font-size-16 ff-sora secondary-black fw-normal px-4"
                    style={{
                      width: "100%",
                      maxWidth: "412px",
                      height: "56px",
                      border: "none",
                    }}
                    as={Input}
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-danger font-size-12 ff-sora fw-normal my-1"
                  />
                </FormGroup>
                <div className="mt-4 float-end">
                  <Button
                    type="submit"
                    className="rounded-pill"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save Changes"}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </>
  );
};

export default ChangePassword;
